<template class="banner">
  <div class="banner-container">
  </div>
</template>

<script>
export default {
  name: 'VartaPresentation',
};
</script>

<style scoped>
.banner {
  justify-content: center;
  align-items: center;
}

.banner-container {
  margin: 2rem auto;
  width: 90%;
  height: 40rem; /* Ajusta la altura según tus necesidades */
  display: flex;
  justify-content: flex-start; /* Alinea el contenido hacia la izquierda */
  align-items: center;
  background-image: url('@/assets/Varta/Inicio.png');
  background-size: contain; /* La imagen se ajustará al contenedor sin recortarse */
  background-position: center; /* Centra la imagen en el contenedor */
  background-repeat: no-repeat; /* Evita que la imagen se repita */
}


@media (max-width: 1000px) {
  .banner-container {
      width: 100%; /* Ocupa el 100% del ancho en pantallas pequeñas */
      height: 20rem; /* Reduce la altura del banner en móviles */
      padding-left: 1rem; /* Reduce el padding en pantallas pequeñas */
      justify-content: center; /* Centra el contenido en pantallas móviles */
      background-image: url('@/assets/Varta/Inicio - movil.png');
      background-position: left; /* Muestra solo la parte derecha de la imagen */
      background-size: cover; /* Asegura que la imagen cubra todo el contenedor */
      position: relative; /* Necesario para la capa oscura */
    }   
}
@media (max-width: 768px) {
  .banner-container {
      width: 100%; /* Ocupa el 100% del ancho en pantallas pequeñas */
      height: 10rem; /* Reduce la altura del banner en móviles */
      padding-left: 1rem; /* Reduce el padding en pantallas pequeñas */
      justify-content: center; /* Centra el contenido en pantallas móviles */
      background-image: url('@/assets/Varta/Inicio - movil.png');
      background-position: left; /* Muestra solo la parte derecha de la imagen */
      background-size: cover; /* Asegura que la imagen cubra todo el contenedor */
      position: relative; /* Necesario para la capa oscura */
    }
}
</style>
